import { getStatusText } from "../../../utils/statusUtils";

export const mapApiToCalendarEvent = (event, locale, route, translate) => {
    const startDate = new Date(
        `${event.scheduleDate}T${event.scheduleTime}:00`
    );
    const endDate = new Date(startDate.getTime() + 1.6 * 60 * 60 * 1000);
    const result =
        event.homeGoals && event.awayGoals
            ? `(${event.homeGoals}:${event.awayGoals})`
            : null;
    const statusText = translate(getStatusText(event.status));

    return {
        title: `${event.name}`,
        start: startDate,
        extendedProps: {
            id: event.id,
            locale: locale,
            pitch: event.pitch?.name,
            pitchId: event.pitch?.id,
            result: result,
            ageGroup: event.ageGroup,
            league: event.league,
            status: statusText,
            path: route?.path ? route?.path : "",
            t: translate,
        },
        backgroundColor: "#52b6ca",
        borderColor: "#52b6ca",
        end: endDate,
    };
};
